export { Companies as Section1_2 } from './Companies'
